export const PREDEFINED_COUNTRY_CODES = {
  UA: '+999 (99) 999-99-99',
  TR: '+99 999 999 99 99',
  HR: '+999 99 9999999'
} as const;

export const MAX_CODE_LENGTH = 3;
